import { render } from "./ParcelCharts.vue?vue&type=template&id=0183d87e&ts=true"
import script from "./ParcelCharts.vue?vue&type=script&lang=ts"
export * from "./ParcelCharts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__